// @ts-ignore
import Index from './src/Index.vue'
import {withInstall} from "@verdure/core";

Index.name = 'verdure-image';
export const VerdureImage = withInstall(Index);

export default VerdureImage;
